import { createRoot } from 'react-dom/client';
import LaasShippingLeadForm from './car-shipping/LaasLeadForm';
import ErrorBoundary from '../../components/ErrorBoundary';
import onDomContentLoaded from '../../utilities/onDomContentLoaded';
import '../../../scss/pages/car-shipping/main.scss';

const carShippingApp = document.getElementById('car-shipping-app');

function startup() {
    if (carShippingApp) {
        const root = createRoot(carShippingApp);
        root.render(
            <ErrorBoundary>
                <LaasShippingLeadForm />
            </ErrorBoundary>,
        );
    }
}

onDomContentLoaded(() => {
    startup();
});
